document.addEventListener("DOMContentLoaded", () => {
  const hamburger = document.querySelector(".hamburger-menu");
  const close = document.querySelector(".close");
  const header = document.querySelector("header");
  const section = document.querySelector(".section-header");
  const topbar = document.querySelector(".announcement-bar-section");

  hamburger.addEventListener("click", () => {
    header.classList.add("open");
    header.style.yOverflow = "auto";

    section.style.zIndex = "100";
    section.style.position = "absolute";

    disableScroll();
  });

  close.addEventListener("click", () => {
    header.classList.remove("open");

    section.style.zIndex = "3";
    section.style.position = "fixed";

    enableScroll();
  });

  function disableScroll() {
    document.body.style.overflow = "hidden";
  }

  function enableScroll() {
    document.body.style.overflow = "auto";
  }

  // Closing menu item when other menu item gets opened
	const detailsElements = document.querySelectorAll(".nav-items details");

	for (const details of detailsElements) {
		details.addEventListener("toggle", (event) => {
			if (details.open) {
				for (const otherDetails of detailsElements) {
					if (otherDetails !== details && otherDetails.open) {
						otherDetails.open = false;
					}
				}
			}
		});
	}

  window.addEventListener('scroll', () => {
    let height = '47px';

    if (window.innerWidth >= 1200) {
      height = '54.8px';
    }

    if (window.scrollY > 100) {
      topbar.style.top = `-${height}`;       // hide topbar
      section.style.top = '0';           // move navbar up
    } else {
      topbar.style.top = '0';           // show topbar
      section.style.top = height;        // shift navbar down
    }
  });
});
